import styled from 'styled-components';

const EmptyImg = styled.div`
  /* min-height: 530px; */
  margin: 0 auto;
  padding: 40px 0;
  text-align: center;
  color: #999999;
  white-space: nowrap;
  font-size: 14px;
  .img {
    background: url(${require('./images/empty.png')}) center 0 no-repeat;
    background-size: 168px 168px;
    height: 168px;
    &.box {
      background-image: url(${require('./images/empty-box.png')});
    }
    &.focus {
      background-image: url(${require('./images/empty-focus.png')});
    }
  }
  ._dark & .img {
    background-image: url(${require('./images/empty-dark.png')});
  }
`;

const EmptyText = styled.div`
  color: #a3a3a3;
  white-space: nowrap;
  font-size: 14px;
  padding: 32px;
  display: block;
  width: 100%;
  text-align: center;
`;

const Index = (props) => {
  const { children, hideImg = false, className = '', type = '' } = props;

  if (hideImg) {
    return <EmptyText>{children}</EmptyText>;
  }

  return (
    <EmptyImg className={`list-empty ${className}`}>
      <div className={`img ${type}`} />
      <div>{children}</div>
    </EmptyImg>
  );
};

export default Index;
